export default __webpack_public_path__ + "static/media/protect.e3ce2a9b.PNG";